module.exports = __webpack_public_path__ + "img/error.f3704abc.png";